import type { BuildingAnalyticEntityType } from "building-types/entities/buildingEntityTypeTypes";
import type { BuildingEntityType } from "building-types/entities/buildingEntityTypeTypes";
import type { BuildingTableFieldNames } from "./buildingTableFieldNames";

export type TableBasedBuildingEntityType =
  | BuildingAnalyticEntityType
  | Extract<
      BuildingEntityType,
      | "ANNOTATION"
      | "CASEWORK"
      | "CEILING"
      | "COLUMN"
      | "CORNER_BOARDS"
      | "DIMENSION"
      | "DOOR"
      | "DRIVEWAY"
      | "FOUNDATION_SUPER_SYSTEM"
      | "FLOOR_SYSTEM"
      | "FOUNDATION_SYSTEM"
      | "FOUNDATION_SYSTEM_HORIZONTAL_ASSEMBLY"
      | "LUMBER"
      | "PORCH"
      | "PROP"
      | "RAILING"
      | "ROOF_SYSTEM"
      | "ROOF_VOLUME"
      | "ROOF_SOFFIT"
      | "ROOM"
      | "SITE"
      | "SKYLIGHT"
      | "STAIR_SYSTEM"
      | "WALL_STRUCTURAL_DOMAIN"
      | "WAINSCOTING"
      | "WALL_PLANE"
      | "WALL"
      | "WALL_SYSTEM"
      | "WINDOW"
    >;

export const entityTypeToTableName = {
  ANALYTIC_FOUNDATION: "analyticFoundationEntities",
  ANALYTIC_COLUMN: "analyticColumnEntities",
  ANALYTIC_PORCH: "analyticPorchEntities",
  ANALYTIC_FOUNDATION_SUPER_SYSTEM: "analyticFoundationSuperSystemEntities",
  ANALYTIC_FOUNDATION_HORIZONTAL_ASSEMBLY: "analyticFoundationHorizontalAssemblyEntities",
  ANALYTIC_WALL: "analyticWallEntities",
  ANALYTIC_ROOF: "analyticRoofEntities",
  ANALYTIC_CEILING: "analyticCeilingEntities",
  ANALYTIC_ROOF_SOFFIT: "analyticRoofSoffitEntities",
  ANALYTIC_DOOR_TRIM: "analyticDoorTrimEntities",
  ANALYTIC_WINDOW_TRIM: "analyticWindowTrimEntities",
  ANALYTIC_INTERIOR_TRIM: "analyticInteriorTrimEntities",
  ANALYTIC_RAILING: "analyticRailingEntities",
  ANALYTIC_WALL_STRUCTURAL_DOMAIN: "analyticWallStructuralDomainEntities",
  ANALYTIC_FLOOR_STRUCTURE: "analyticFloorStructureEntities",
  ANALYTIC_EXTERIOR_FINISH_EDGE: "analyticExteriorFinishEdgeEntities",
  ANNOTATION: "annotation",
  CASEWORK: "casework",
  CEILING: "ceilings",
  COLUMN: "columns",
  CORNER_BOARDS: "cornerBoards",
  DIMENSION: "dimensions",
  DOOR: "doorUnits",
  DRIVEWAY: "driveways",
  FOUNDATION_SUPER_SYSTEM: "foundationSuperSystems",
  FOUNDATION_SYSTEM: "foundations",
  FOUNDATION_SYSTEM_HORIZONTAL_ASSEMBLY: "foundationHorizontalAssemblies",
  LUMBER: "lumberRails",
  FLOOR_SYSTEM: "floorSystems",
  PORCH: "porches",
  PROP: "props",
  RAILING: "railings",
  ROOF_SYSTEM: "roofSystems",
  ROOF_VOLUME: "roofVolumes",
  ROOF_SOFFIT: "roofSoffits",
  ROOM: "rooms",
  SITE: "sites",
  SKYLIGHT: "skylightUnits",
  STAIR_SYSTEM: "stairSystems",
  WALL_STRUCTURAL_DOMAIN: "wallStructuralDomains",
  WAINSCOTING: "wainscoting",
  WALL_PLANE: "wallPlanes",
  WALL: "wallLayers",
  WALL_SYSTEM: "walls",
  WINDOW: "windowUnits",
} satisfies Record<TableBasedBuildingEntityType, BuildingTableFieldNames>;

export function buildingEntityTypeIsTableBased(
  entityType: BuildingEntityType,
): entityType is TableBasedBuildingEntityType {
  return entityType in entityTypeToTableName;
}
